import type { IconId } from '#/components/ui/icons';
import { Icon } from '#/components/ui/icons';

export function IconLabel({
  label,
  icon = 'folder',
}: {
  label: string;
  icon?: IconId;
}) {
  return (
    <div className="flex items-center gap-x-8">
      <div className="bg-steel-30 flex size-32 items-center justify-center rounded-full">
        <Icon id={icon} className="size-16 text-slate-50" />
      </div>

      <span className="text-fg-muted text-static-16 leading-none">{label}</span>
    </div>
  );
}
